/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { OrganizationDisplayInfo, OrganizationInfo } from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getOrgInfo = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<OrganizationInfo>> => {
    return axios.get(`/api/org-info`, options);
};

export const getGetOrgInfoQueryKey = () => {
    return [`/api/org-info`] as const;
};

export const getGetOrgInfoQueryOptions = <
    TData = Awaited<ReturnType<typeof getOrgInfo>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getOrgInfo>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetOrgInfoQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgInfo>>> = ({
        signal,
    }) => getOrgInfo({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getOrgInfo>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrgInfoQueryResult = NonNullable<
    Awaited<ReturnType<typeof getOrgInfo>>
>;
export type GetOrgInfoQueryError = AxiosError<unknown>;

export function useGetOrgInfo<
    TData = Awaited<ReturnType<typeof getOrgInfo>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOrgInfo>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getOrgInfo>>,
                    TError,
                    Awaited<ReturnType<typeof getOrgInfo>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrgInfo<
    TData = Awaited<ReturnType<typeof getOrgInfo>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOrgInfo>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getOrgInfo>>,
                    TError,
                    Awaited<ReturnType<typeof getOrgInfo>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrgInfo<
    TData = Awaited<ReturnType<typeof getOrgInfo>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOrgInfo>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOrgInfo<
    TData = Awaited<ReturnType<typeof getOrgInfo>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOrgInfo>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetOrgInfoQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetOrgInfoSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getOrgInfo>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getOrgInfo>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetOrgInfoQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgInfo>>> = ({
        signal,
    }) => getOrgInfo({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrgInfo>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrgInfoSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getOrgInfo>>
>;
export type GetOrgInfoSuspenseQueryError = AxiosError<unknown>;

export function useGetOrgInfoSuspense<
    TData = Awaited<ReturnType<typeof getOrgInfo>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOrgInfo>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrgInfoSuspense<
    TData = Awaited<ReturnType<typeof getOrgInfo>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOrgInfo>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrgInfoSuspense<
    TData = Awaited<ReturnType<typeof getOrgInfo>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOrgInfo>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOrgInfoSuspense<
    TData = Awaited<ReturnType<typeof getOrgInfo>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOrgInfo>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetOrgInfoSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getOrgDisplayInfo = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<OrganizationDisplayInfo>> => {
    return axios.get(`/api/org-display-info`, options);
};

export const getGetOrgDisplayInfoQueryKey = () => {
    return [`/api/org-display-info`] as const;
};

export const getGetOrgDisplayInfoQueryOptions = <
    TData = Awaited<ReturnType<typeof getOrgDisplayInfo>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof getOrgDisplayInfo>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetOrgDisplayInfoQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getOrgDisplayInfo>>
    > = ({ signal }) => getOrgDisplayInfo({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getOrgDisplayInfo>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrgDisplayInfoQueryResult = NonNullable<
    Awaited<ReturnType<typeof getOrgDisplayInfo>>
>;
export type GetOrgDisplayInfoQueryError = AxiosError<unknown>;

export function useGetOrgDisplayInfo<
    TData = Awaited<ReturnType<typeof getOrgDisplayInfo>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOrgDisplayInfo>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getOrgDisplayInfo>>,
                    TError,
                    Awaited<ReturnType<typeof getOrgDisplayInfo>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrgDisplayInfo<
    TData = Awaited<ReturnType<typeof getOrgDisplayInfo>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOrgDisplayInfo>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getOrgDisplayInfo>>,
                    TError,
                    Awaited<ReturnType<typeof getOrgDisplayInfo>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrgDisplayInfo<
    TData = Awaited<ReturnType<typeof getOrgDisplayInfo>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOrgDisplayInfo>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOrgDisplayInfo<
    TData = Awaited<ReturnType<typeof getOrgDisplayInfo>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getOrgDisplayInfo>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetOrgDisplayInfoQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetOrgDisplayInfoSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getOrgDisplayInfo>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getOrgDisplayInfo>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetOrgDisplayInfoQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getOrgDisplayInfo>>
    > = ({ signal }) => getOrgDisplayInfo({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getOrgDisplayInfo>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrgDisplayInfoSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getOrgDisplayInfo>>
>;
export type GetOrgDisplayInfoSuspenseQueryError = AxiosError<unknown>;

export function useGetOrgDisplayInfoSuspense<
    TData = Awaited<ReturnType<typeof getOrgDisplayInfo>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOrgDisplayInfo>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrgDisplayInfoSuspense<
    TData = Awaited<ReturnType<typeof getOrgDisplayInfo>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOrgDisplayInfo>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrgDisplayInfoSuspense<
    TData = Awaited<ReturnType<typeof getOrgDisplayInfo>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOrgDisplayInfo>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOrgDisplayInfoSuspense<
    TData = Awaited<ReturnType<typeof getOrgDisplayInfo>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getOrgDisplayInfo>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetOrgDisplayInfoSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
